export default __webpack_public_path__ + "static/eberle-b704e507ef9acd98063885ec4dc530a5.jpg";